<zn-hierarchical-view
  [rootComponentInstance]="this"
  [hideCreateButton]="true"
  [disableCanDelete]="true"
  [disableEdit]="true"
  [disableEditInline]="true"
/>
<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>